import ShButton from '@/components/Helpers/ShButton';
import SmsHistoryListItem from './SmsHistoryListItem';
import SmsHistorySearchPanel from './SmsHistorySearchPanel';
import { hDeepCopy }  from '@/utils/helpers';
import moment from 'moment';
import EmptyList from '@/components/Common/EmptyList';

// @vue/component
export default {
  name: 'SmsHistory',

  components: {
    ShButton,
    SmsHistoryListItem,
    SmsHistorySearchPanel,
    EmptyList
  },

  props: {
  },

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
      filterBy: {
        number: '',
        type: '',
        status: '',
        send_time: [],
        delivered_time: [],
        src: '',
      }
      
    };
  },
  watch: {
    filterBy: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    itemsPerPage: {
      handler() {
        this.currentPage = 1;
      }
    }
  },
  
  computed: {
    smsHistoryList() {
      return this.$store.getters['sms/historyList'];
    },
    smsHistoryFilteredList() {
      let filteredHistoryList = hDeepCopy(this.smsHistoryList.records)
      if (this.filterBy.number) {
        filteredHistoryList = filteredHistoryList.filter(item => item.dst.includes(this.filterBy.number));
      }
      if (this.filterBy.type) {
        filteredHistoryList = filteredHistoryList.filter(item => item.type === this.filterBy.type);
      }
      if (this.filterBy.status) {
        filteredHistoryList = filteredHistoryList.filter(item => item.status === this.filterBy.status);
      }
      if (this.filterBy.send_time && this.filterBy.send_time.length > 0) {
        filteredHistoryList = filteredHistoryList.filter(item => moment(item.send_time).isBetween(this.filterBy.send_time[0], this.filterBy.send_time[1]));
      }
      if (this.filterBy.delivered_time && this.filterBy.delivered_time.length > 0) {
        filteredHistoryList = filteredHistoryList.filter(item => moment(item.delivered_time).isBetween(this.filterBy.delivered_time[0], this.filterBy.delivered_time[1]));
      }
      if (this.filterBy.src) {
        filteredHistoryList = filteredHistoryList.filter(item => item.uuid_src === this.filterBy.src);
      }
      return filteredHistoryList;
    },
    historyItemsToRenderPerPage() {
      return this.smsHistoryFilteredList.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
    },
    statusList() {
      return this.$store.getters['sms/statusList'];
    },
    typeList() {
      return this.$store.getters['sms/typeList'];
    },
    isEmpty() {
      return this.smsHistoryList.total === 0;
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'sms/getSmsHistoryList',
        'sms/getRefreshAllSmsStatus'
      ]);
    },
    isSinglePage() {
      return this.smsHistoryFilteredList.length <= this.itemsPerPage;
    },
    isDisabled() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes(['sms/getRefreshAllSmsStatus'])
    }
  },


  methods: {
    getSmsHistoryList() {
      this.$store.dispatch('sms/getSmsHistoryList');
    },
    changeFilterBy(value) {
      this.filterBy = value
    },
    handleChangePage(page) {
      this.currentPage = page;
    },
    async refreshAllSmsStatus() {
      const responseStatus = await this.$store.dispatch('sms/getRefreshAllSmsStatus');
      if (responseStatus === 200) {
        await this.$store.dispatch('sms/getSmsHistoryList');
        this.$message({
          type: 'success',
          message: "Dane zostały odświeżone.",
        });
      } else {
        this.$message({
          type: 'error',
          message: "Wystąpił błąd podczas odświeżania danych.",
        });
      }
    },
  },
  created() {
    this.getSmsHistoryList();
  }
};
